import { IconSvgProps } from "@modules/ui/components/huButtonIcon"

/**
 * Icon for BoxStaffCoach, it's a cap
 * @param props
 * @returns
 */
export const BoxStaffCoachIcon: React.FC<IconSvgProps> = (props) => (
  <svg
    width={props.size}
    height={props.size}
    viewBox="0 0 50 50"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    {...props}
  >
    <mask
      id="mask0_12013_138024"
      maskUnits="userSpaceOnUse"
      x="12"
      y="10"
      width="32"
      height="23"
      style={{ maskType: "alpha" }}
    >
      <path
        d="M13.6472 17.8557C12.277 21.1553 12.7826 28.0353 12.7826 28.0353C12.7826 28.0353 16.3859 30.3356 18.9676 31.1279C24.4621 32.8141 28.1752 31.9525 33.6571 30.2259C37.6072 28.9818 43.0636 25.3294 43.0636 25.3294V22.7522H41.3885C41.3885 22.7522 41.5015 20.2279 40.9653 18.3924C40.268 16.0048 39.465 14.3661 37.5228 12.8303C36.3608 11.9114 28.6954 10.0233 23.3487 11.5418C18.5145 12.9147 14.7957 15.0901 13.6472 17.8557Z"
        fill="#6450F7"
      />
    </mask>
    <g mask="url(#mask0_12013_138024)">
      <path
        d="M13.6472 17.8557C12.277 21.1553 12.7826 28.0353 12.7826 28.0353C12.7826 28.0353 16.3859 30.3356 18.9676 31.1279C24.4621 32.8141 28.1752 31.9525 33.6571 30.2259C37.6072 28.9818 43.0636 25.3294 43.0636 25.3294V22.7522H41.3885C41.3885 22.7522 41.5015 20.2279 40.9653 18.3924C40.268 16.0048 39.465 14.3661 37.5228 12.8303C36.3608 11.9114 28.6954 10.0233 23.3487 11.5418C18.5145 12.9147 14.7957 15.0901 13.6472 17.8557Z"
        fill="#6450F7"
      />
      <circle cx="31.9562" cy="26.3365" r="12.548" fill="#3B3184" />
    </g>
    <mask
      id="mask1_12013_138024"
      style={{ maskType: "alpha" }}
      maskUnits="userSpaceOnUse"
      x="5"
      y="27"
      width="30"
      height="12"
    >
      <path
        d="M12.8602 27.8618C12.8602 27.8618 16.0299 28.5372 18.0784 28.8718C24.2585 29.8813 34.0698 30.0501 34.0698 30.0501L24.7959 37.8283C24.1085 38.4047 23.1209 38.4549 22.3542 37.9892C20.2958 36.7392 16.1465 34.4682 12.8602 34.2584C10.9288 34.135 8.49229 34.6722 6.58021 35.2235C5.94996 35.4052 5.4217 34.5033 5.91098 34.0664L12.8602 27.8618Z"
        fill="#D9D9D9"
      />
    </mask>
    <g mask="url(#mask1_12013_138024)">
      <path
        d="M12.8602 27.8618C12.8602 27.8618 16.0299 28.5372 18.0784 28.8718C24.2585 29.8813 34.0698 30.0501 34.0698 30.0501L24.3151 38.2315C23.912 38.5696 23.3351 38.6007 22.8899 38.3204C21.1062 37.1976 16.4643 34.4885 12.8602 34.2584C10.9288 34.135 8.49229 34.6722 6.58021 35.2235C5.94996 35.4052 5.4217 34.5033 5.91098 34.0664L12.8602 27.8618Z"
        fill="#3B3184"
      />
      <circle cx="9.80847" cy="20.3395" r="17.4452" fill="#6450F7" />
    </g>
  </svg>
)
